
import React, { Component, Fragment } from 'react'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'

import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import WebImage from "../../assets/images/service/web-development00.jpg";



class WebsiteDevelopment extends Component {
     render() {
          return (
               <Fragment>

               
              <Container fluid={true}  className="BetweenTwoSection">
                <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Service </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/website-development">Website Development</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
        
         <h2 className="section-title text-center mb-2 text-primary"> Website Development Services</h2>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={6} xs={12}>
           <img  className="product-main"  src={WebImage}  alt="ParkEase Dashboard"/>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4>At ChrisAlpha Company</h4>
          
          <p> we provide
              professional website development services designed to help businesses,
              organizations, and individuals establish a strong online presence.
              Our team builds modern, secure, and user-friendly websites tailored
              to meet your specific needs.</p>
          <div className="">
           <h6>   Custom Website Development</h6>
             
          <p> 
                We design and develop fully customized websites that reflect your
                brand identity. Whether you need a business website, portfolio,
                or corporate platform, we deliver responsive and scalable solutions.
              </p>

          </div>

           <div className="mt-6">
              <h6 className="text-xl font-semibold mb-2">
                Website Maintenance & Support
              </h6>

              <p>
                We provide ongoing maintenance, updates, and technical support
                to ensure your website remains secure and up-to-date.
              </p>
            </div>

            <div className="mt-6">
              <h6 className="text-xl font-semibold mb-2">
                Responsive & Mobile-Friendly Design
              </h6>

              <p>
                All websites developed by ChrisAlpha are optimized for mobile,
                tablet, and desktop devices.
              </p>
            </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
             <p>Our websites are designed to be responsive, meaning they work smoothly on mobile phones, tablets, and computers. We focus on creating fast, attractive, and reliable websites that make it easy for customers to find information, contact your business, and access your services anytime.

We also develop custom web systems such as business management systems, booking platforms, dashboards, and online service portals that improve efficiency and simplify daily operations.</p>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <p className=" p-0 m-0"><span className="Review-Title">  Web designer You Can Trust</span><span className="text-success"> </span>    </p>
          <p>We design website best for your company to attract all the world </p>

          <p className=" p-0 m-0"><span className="Review-Title">Your Partner in Technology</span> <span className="text-success"> </span> </p>
          <p>Delivering efficient, reliable, and secure technology solutions tto your area .</p>

          </Col>
     </Row>
</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default WebsiteDevelopment